import { Injectable } from '@angular/core'
import { LocalAutocompletionService } from 'main/services/localAutocompletion.service'
import { CustomField } from 'elements-sdk'

@Injectable({ providedIn: 'root' })
export class CustomFieldsService {
  constructor (
    private localAutocompletion: LocalAutocompletionService,
  ) { }

  combine (...parts: (Record<any, any>|null|undefined)[]): Record<any, any> {
    let result = {}

    for (const part of parts) {
      if (part) {
        const filtered = Object.fromEntries(
          Object.entries(part).filter(([_, v]) => v != null))
        result = { ...result, ...filtered }
      }
    }

    return result
  }

  registerAutocompletion<T> (field: CustomField, value: T): void {
    if (field.type && field.type !== 'text') {
      return
    }
    this.localAutocompletion.register('customField', field.name, value)
  }

  getAutocompletions (field: CustomField, query: string): string[] {
    return this.localAutocompletion.get('customField', field.name, query)
  }
}
